import DataNotFound from 'components/DataNotFound/DataNotFound';
import RankedProgressList from 'components/AiAnalytics/shared/RankedProgressList/RankedProgressList';
import { BaseWidget } from 'models/WidgetModel';
import React, { useMemo } from 'react';
import { mapFrictionSignalsResponse } from './frictionSignals.mapper';
import './FrictionSignals.scss';

const FrictionSignals: React.FC<BaseWidget> = ({ response }) => {
  const view = useMemo(() => mapFrictionSignalsResponse(response), [response]);
  if (!view) return <DataNotFound />;
  return (
    <div className="friction-signals">
      {view.items.some((item) => item.percent > 0) ? (
        <RankedProgressList items={view.items} formatPercent={(percent) => `(${percent}%)`} />
      ) : (
        <div className="friction-signals__no-activity">No activity</div>
      )}
    </div>
  );
};
export default FrictionSignals;
